import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { getRequestUrl } from "@tanstack/react-start/server"
import { env } from "cloudflare:workers"

import { getRedirectTarget } from "../redirect"
import { hasUserRole } from "../roles.server"
import { getSessionUser } from "../session.server"

const LOGIN_ROUTE = "/login"

export const requireUserId = createServerFn({ method: "GET" })
  .validator((data?: { redirectTo?: string }) => data)
  .handler(async ({ data }) => {
    const user = await getSessionUser()

    if (!user) {
      const requestURLObject = getRequestUrl()
      const redirectToURL =
        data?.redirectTo ?? `${requestURLObject.pathname}${requestURLObject.search}`
      throw redirect(
        redirectToURL
          ? { to: LOGIN_ROUTE, search: { redirectTo: redirectToURL } }
          : { to: LOGIN_ROUTE },
      )
    }

    return user.id
  })

export const requireGuestUser = createServerFn({ method: "GET" })
  .validator((data?: { redirectTo?: string }) => data)
  .handler(async ({ data }) => {
    if (await getSessionUser()) {
      throw redirect(getRedirectTarget(data?.redirectTo))
    }
  })

export const requireAuthConfiguration = createServerFn({
  method: "GET",
}).handler(async () => {
  const missing = (["SUPABASE_URL", "SUPABASE_PUBLISHABLE_KEY"] as const).filter((key) => !env[key])
  if (missing.length > 0) {
    throw new Error(`Authentication is not configured: set ${missing.join(", ")}`)
  }
})

export const requireUserRole = createServerFn({ method: "GET" })
  .validator((data: { userId: string; roleName: string }) => data)
  .handler(async ({ data: { userId, roleName } }) => {
    if (!(await hasUserRole(userId, roleName))) {
      throw new Error("User does not have the required role")
    }
  })
